import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class PageContentTypeParser implements Parser {
	parse(schema: Record<string, Schema.PageContentType>) {
		const names = Object.keys(schema).map((name) => `"${name}"`);

		return names.length
			? `export type PageContentTypes = ${names.join("|")}`
			: "";
	}
}
